import React from "react";
import background from "../../assets/Quote.jpg";
import DropContact from "../Components/DropContact";
import QuoteCard from "../Components/QuoteForm";

const Quote = () => {
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

    .quote-page { font-family: 'DM Sans', sans-serif; position: relative; overflow-x: hidden; }

    .quote-bg { position: absolute; inset: 0; background-size: cover; background-position: center; filter: grayscale(25%); z-index: 0; }
    .quote-overlay { position: absolute; inset: 0; background: linear-gradient(160deg, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.72) 100%); z-index: 1; }

    .quote-content {
      position: relative; z-index: 2;
      max-width: 1200px;
      margin: 0 auto;
      padding: 8rem 2rem 6rem;
      width: 100%;
      box-sizing: border-box;
    }

    .quote-header { text-align: center; margin-bottom: 4rem; }
    .quote-eyebrow { display: inline-flex; align-items: center; gap: 0.75rem; margin-bottom: 1.75rem; }
    .quote-eyebrow-line { width: 28px; height: 1px; background: #E78730; flex-shrink: 0; }
    .quote-eyebrow-text { font-size: 0.68rem; letter-spacing: 0.26em; text-transform: uppercase; color: #E78730; font-weight: 500; }

    .quote-h1 { font-family: 'DM Serif Display', serif; font-size: clamp(2.5rem, 6vw, 5rem); line-height: 0.98; color: #fff; margin-bottom: 1.25rem; }
    .quote-h1 em { color: #E78730; font-style: italic; }
    .quote-sub { font-size: 0.95rem; color: rgba(255,255,255,0.4); line-height: 1.8; font-weight: 300; max-width: 48ch; margin: 0 auto; }
    .quote-header-rule { width: 40px; height: 1px; background: rgba(255,255,255,0.15); margin: 2.5rem auto 0; }

    .quote-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5rem;
      align-items: start;
      width: 100%;
      box-sizing: border-box;
    }

    .quote-card {
      background: #fff;
      border-top: 2px solid #E78730;
      width: 100%;
      box-sizing: border-box;
      min-width: 0;
    }

    .quote-card-header { padding: 1.5rem 2rem; border-bottom: 1px solid #e8e8e4; display: flex; align-items: center; gap: 0.6rem; }
    .quote-card-header-line { width: 16px; height: 1px; background: #E78730; flex-shrink: 0; }
    .quote-card-label { font-size: 0.65rem; letter-spacing: 0.22em; text-transform: uppercase; color: #888; font-weight: 500; }
    .quote-card-body { padding: 2rem 2rem; }

    /* Mobile */
    @media (max-width: 860px) {
      .quote-grid { grid-template-columns: 1fr; gap: 2rem; }
      .quote-content { padding: 6rem 1.5rem 4rem; }
    }

    @media (max-width: 560px) {
      .quote-content { padding: 6rem 1rem 4rem; }
      .quote-card-header { padding: 1.25rem 1.25rem; }
      .quote-card-body { padding: 1.5rem 1.25rem; }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="quote-page">
        <div
          className="quote-bg"
          style={{ backgroundImage: `url(${background})` }}
        />
        <div className="quote-overlay" />

        <div className="quote-content">
          <div className="quote-header">
            <div className="quote-eyebrow">
              <span className="quote-eyebrow-line" />
              <span className="quote-eyebrow-text">No Obligation</span>
              <span className="quote-eyebrow-line" />
            </div>
            <h1 className="quote-h1">
              Get Your <em>Free Quote</em>
            </h1>
            <p className="quote-sub">
              Fill out the form and we'll get back to you within 24 hours.
            </p>
            <div className="quote-header-rule" />
          </div>

          <div className="quote-grid">
            <div className="quote-card">
              <div className="quote-card-header">
                <span className="quote-card-header-line" />
                <span className="quote-card-label">Request a Quote</span>
              </div>
              <div className="quote-card-body">
                <QuoteCard />
              </div>
            </div>

            <div className="quote-card">
              <div className="quote-card-header">
                <span className="quote-card-header-line" />
                <span className="quote-card-label">Request a Call Back</span>
              </div>
              <div className="quote-card-body">
                <DropContact />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quote;
